import { getCurrentEnv } from 'app/helpers/getCurrentEnv';
import { AppNS } from 'app';

export const trackGTMEvent = (
  event: string, props: AppNS.Params
) => {
  if (getCurrentEnv() === 'production') {
    if (event) {
      window.dataLayer.push({
        event,
        eventProps: props
      })
    }
  }
};
